import React, { useState } from "react";
import styles from "./styles";
import RightPannel from "../../../components/RightPannel";
import EditProfile from "../../../../../Diathrive/src/containers/EditProfile";
import CustomDatePicker from "../../../components/elements/CustomDatePicker";
import { useDisableBodyScroll } from "../../../../../Diathrive/src/hooks/use-disable-dody-scroll";
import { Camera } from "expo-camera";
import { useNavigate, useOutletContext } from "react-router-dom";
import { tID } from "../../../../../Diathrive/src/utils/TestIdHelper";
import ChangePassword from "../../../../../Diathrive/src/containers/ChangePassword";
import Button from "../../../../../Diathrive/src/components/elements/Button";
import {
  BUTTON_TYPES,
  COLORS,
} from "../../../../../Diathrive/src/utils/Constants";
import ChangePhoneNumber from "../../../../../Diathrive/src/containers/ChangePhoneNumber";
import ChangePhoneNumberVerification from "../../../../../Diathrive/src/containers/ChangePhoneNumberVerification";

const MyProfile = () => {
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [camera, setCamera] = useState(null);
  const [openCamera, setOpenCamera] = useState(false);
  const [imageUri, setImageUri] = useState();
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const [showChangePhoneNumberPopup, setShowChangePhoneNumberPopup] =
    useState(false);
  const [showVerifyPhoneNumberPopup, setShowVerifyPhoneNumberPopup] =
    useState(false);
  const [verifyPhoneNumber, setVerifyPhoneNumber] = useState("");

  const cameraType =
    Camera?.Constants?.Type?.back ??
    Camera?.Constants?.Type?.front ??
    Camera?.Constants?.Type ??
    "back";

  const navigate = useNavigate();

  const { openMyProfile, setOpenMyProfile } = useOutletContext();

  //hook to disable scrolling for web
  useDisableBodyScroll(openMyProfile);

  const takePicture = async () => {
    if (camera) {
      const data = await camera.takePictureAsync(null);
      setImageUri(data.uri);
      setOpenCamera(false);
    }
  };

  return (
    <>
      <RightPannel
        componentToPassDown={
          <EditProfile
            navigation={navigate}
            onDobChange={setDateOfBirth}
            dob={dateOfBirth}
            onClose={() => setOpenMyProfile(false)}
            onOpenCameraClick={() => setOpenCamera(true)}
            imageUri={imageUri}
            setShowChangePasswordPopup={setShowChangePasswordPopup}
            setShowChangePhoneNumberPopup={setShowChangePhoneNumberPopup}
            showVerifyPhoneNumberPopup={showVerifyPhoneNumberPopup}
          >
            <CustomDatePicker
              selected={dateOfBirth}
              onChange={setDateOfBirth}
              name="Date of Birth"
            />
          </EditProfile>
        }
        open={openMyProfile}
        onClose={() => setOpenMyProfile(false)}
      />
      {openCamera ? (
        <div
          data-testid={tID("MyProfile-div-CameraOverlay")}
          style={styles.cameraOverlay}
        >
          <Camera
            testID={tID("MyProfile-Camera-ProfilePicture")}
            ref={(ref) => setCamera(ref)}
            style={styles.camera}
            type={cameraType}
            ratio={"1:1"}
          />
          <div
            data-testid={tID("MyProfile-div-CameraActionButtons")}
            style={styles.actionButtonsContainer}
          >
            <Button
              testID={tID("MyProfile-Button-Cancel")}
              style={styles.cancelButton}
              titleColor={COLORS.white}
              onPress={() => setOpenCamera(false)}
              title={"Cancel"}
            />
            <Button
              testID={tID("MyProfile-Button-Capture")}
              buttonType={BUTTON_TYPES.Filled}
              titleColor={COLORS.white}
              title={"Capture"}
              onPress={takePicture}
              style={styles.captureButton}
            />
          </div>
        </div>
      ) : null}
      {showChangePasswordPopup && (
        <ChangePassword
          navigation={navigate}
          openPopup={showChangePasswordPopup}
          onClosePopup={() => setShowChangePasswordPopup(false)}
        />
      )}
      {showChangePhoneNumberPopup && (
        <ChangePhoneNumber
          navigation={navigate}
          openPopup={showChangePhoneNumberPopup}
          onClosePopup={(phoneNumber) => {
            setShowChangePhoneNumberPopup(false);
            if (phoneNumber) {
              setVerifyPhoneNumber(phoneNumber);
              setShowVerifyPhoneNumberPopup(true);
            }
          }}
        />
      )}
      {showVerifyPhoneNumberPopup && (
        <ChangePhoneNumberVerification
          navigation={navigate}
          openPopup={showVerifyPhoneNumberPopup}
          onClosePopup={() => setShowVerifyPhoneNumberPopup(false)}
          route={{ params: { phoneNo: verifyPhoneNumber } }}
        />
      )}
    </>
  );
};

export default MyProfile;
